import { classToPlain } from 'class-transformer';
import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';

import { AppError } from '@vk-hr-tek/core/error';

import { InfoTemplateResponse, TemplatesService } from '@app/gen/templates';
import { CompanyEventsStat, CompanyGroupUsers } from '@app/gen/settings';
import { Entity } from '@app/types';

import { ThunkExtra } from '../../../../app/store';
import { SettingsState, SettingsWithRootState } from '../../settings.state';

export const getTemplatePreview = createAsyncThunk<
  InfoTemplateResponse,
  { templateId: string },
  ThunkExtra<SettingsWithRootState>
>(
  'templates/getTemplatePreview',
  async ({ templateId }, { rejectWithValue, extra: { inject } }) => {
    try {
      const templatesService = inject(TemplatesService);

      return await templatesService.getTemplate({
        params: { template_id: templateId },
      });
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const settingsTemplatesPreviewReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<Entity<CompanyEventsStat | CompanyGroupUsers>, string> &
      SettingsState
  >,
) => {
  builder.addCase(getTemplatePreview.pending, (state) => {
    state.templatePreview = {
      status: 'loading',
      data: null,
      error: null,
    };
  });
  builder.addCase(getTemplatePreview.fulfilled, (state, { payload }) => {
    state.templatePreview = {
      status: 'complete',
      data: payload,
      error: null,
    };
  });
  builder.addCase(getTemplatePreview.rejected, (state, { payload, error }) => {
    state.templatePreview = {
      status: 'failed',
      data: null,
      error:
        payload ||
        ({
          info: (error && error.message) || 'Unknown error',
          status: 500,
          source: 'client',
          title: 'Internal client error',
        } as AppError),
    };
  });
};
